<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Season of Sacrifice</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h3 class="books-by-head"><em>Recent titles by Bharti Kirchner from Severn House</em></h3>
<p class="books-by-text-space-after">GODDESS OF FIRE</p>
<p> </p>
<p class="books-by-text-space-after"><em>The Maya Mallick series</em></p>
<p class="books-by-text">SEASON OF SACRIFICE</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?3cc9a0a1